// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1ilSG","inputWrap":"styles_inputWrap__2nANd","input":"styles_input__A3-sB"};